<template>
    <div class="div">
        <div class="row mb-4">
            <div class="col-md-2">
                <select class="form-select" v-model="limit">
                    <option>25</option>
                    <option>50</option>
                    <option>100</option>
                </select>
            </div>
            <div class="col-md-4 ms-auto">
                <div class="input-group">
                    <input type="text" class="form-control" v-model="searchTerm" placeholder="Search all Quotes..">
                    <span class="input-group-text bg-body border-0">
                        <i class="fa fa-search"></i>
                    </span>
                </div>
            </div>
        </div>

        <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm">
            <template #headings>
                <th>
                    <strong class="text-uppercase">Vehicle Type</strong>
                </th>
                <th>
                    <strong class="text-uppercase">Vehicle Count</strong>
                </th>
                <th>
                    <strong class="text-uppercase">Quote Price</strong>
                </th>
                <th>
                    <strong class="text-uppercase">Status</strong>
                </th>
                <th>
                    <strong class="text-uppercase">Collection</strong>
                </th>
                <th>
                    <strong class="text-uppercase">Delivery</strong>
                </th>
                <th>Actions</th>
            </template>
            <template #rows="{data}">
                <tr v-for="quote in data" :key="quote.id">
                    <td>{{ quote.vehicle_type }}</td>
                    <td>{{ quote.vehicle_count }}</td>
                    <td>{{ quote.quote_price }}</td>
                    <td v-html="quote.status"></td>
                    <td v-html="quote.collection" class="text-nowrap"></td>
                    <td v-html="quote.delivery" class="text-nowrap"></td>
                    <td v-html="quote.actions"></td>
                </tr>
            </template>
        </datatable>
    </div>
</template>

<script setup>
    import datatable from '@/components/datatable.vue';
    import { ref } from "vue";

    const props = defineProps({
        ajaxUrl: String,
    });

    const orderBy = ref('customer_contact_name');
    const orderAsc = ref(false);
    const limit = ref(25);
    const searchTerm = ref(null);

    const setOrder = function (input) {
        if (orderBy.value === input) {
            orderAsc.value = ! orderAsc.value;
        } else {
            orderBy.value = input;
            orderAsc.value = true;
        }
    };
</script>

